/** 未設定の既存・新規組織は有効。明示的な false で UI とサーバーの利用を禁止する。 */
export interface OrganizationFeatureSettings {
  uiMockEnabled?: boolean;
  transcriptionEnabled?: boolean;
  publicPageSharingEnabled?: boolean;
}

export type OrganizationFeature = keyof OrganizationFeatureSettings;

export const ORGANIZATION_FEATURE_LABELS = {
  uiMockEnabled: 'UIモック',
  transcriptionEnabled: '文字起こし',
  publicPageSharingEnabled: 'ページを公開して共有',
} satisfies Record<OrganizationFeature, string>;

export function isOrganizationFeatureEnabled(
  settings: OrganizationFeatureSettings | null | undefined,
  feature: OrganizationFeature,
): boolean {
  return settings?.[feature] !== false;
}
